import TwoFA from './ui/TwoFA.vue'

export default TwoFA
